"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RedoUtil = /** @class */ (function () {
    function RedoUtil() {
        this.name = 'redo';
        this.handler = function (editor) {
            editor.redo();
        };
        this.disable = function (editor) { return !editor.redoable; };
    }
    return RedoUtil;
}());
exports.RedoUtil = RedoUtil;
//# sourceMappingURL=redo-util.js.map